<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="用户名:">
          <el-input v-model="searchValue.username"></el-input>
        </el-form-item>
        <el-form-item label="所属游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="searchValue.game_id" label="所属区服:">
          <el-select
            v-model="searchValue.zone_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in serverSelectList"
              :key="i"
              :label="item.name"
              :value="item.zone_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属渠道:">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道包组:">
          <el-select
            v-model="searchValue.group_channel_ids"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelGroupSelectList"
              :key="item.id"
              :label="item.group_name"
              :value="item.group_channel_ids"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期:">
          <el-date-picker
            v-model="date"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchRechargeList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportRecharge()">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID" width="80" fixed="left">
      </el-table-column>
      <el-table-column prop="user.phone" label="手机号" width="180">
      </el-table-column>
      <el-table-column prop="user.username" label="用户名" width="180">
      </el-table-column>
      <el-table-column prop="game.name" label="游戏名" width="180">
      </el-table-column>
      <el-table-column prop="channels.name" label="渠道名" width="240">
      </el-table-column>
      <el-table-column prop="name" label="角色" width="200">
      </el-table-column>
      <el-table-column prop="zone_name" label="区服" width="180">
      </el-table-column>
      <el-table-column
        prop="user.last_login_at"
        label="最近登录时间"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="lately_recharge"
        label="最近充值时间"
        width="200"
      >
      </el-table-column>
      <el-table-column prop="amount" label="金额" width="180">
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
export default {
  name: "recharge",
  components: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date(moment().format("YYYY-MM-DD") + ' 23:59:59').getTime()
        }
      },
      date: [],
      loadingData: false,
      searchValue: {
        username: "",
        game_id: "",
        channel_id: [],
        group_channel_ids: "",
        zone_id: "",
      },
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      gamesList: [],
      channelSelectList: [],
      channelSelectAllList: [],
      channelGroupSelectList: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
      },
      serverSelectList: []
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getchannelSelectList();
    this.channelGroupSelect();
    this.getGameSelectList();
    this.getRechargeList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    // 获取区服选择列表数据
    getServerSelectList(vid) {
      this.serverSelectList =  []
      this.searchValue.zone_id = ''
      fetch({
        url: "/admin/zones/select",
        method: "GET",
        params: {
          game_id: vid,
        },
      }).then((res) => {
        if (res.data.status) {
          this.serverSelectList = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRechargeList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRechargeList(false);
    },

    // 导出
    exportRecharge() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };
      if (this.date && this.date.length) {
        const created_from = this.date.length === 2 && this.date[0]
        const created_to = this.date.length === 2 && this.date[1]
        if (created_from) params['created_from'] = created_from
        if (created_to) params['created_to'] = created_to
      }

      urlSplicing(this.host + "admin/statistics/recharge_list", params);
    },

    // 获取游戏选择列表数据
    getGameSelectList(row) {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },

    // 获取渠道选择列表数据
    getchannelSelectList(row) {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectAllList = res.data.data;
        this.channelSelectList = res.data.data;
      });
    },
    // 渠道包组 下拉选择列表
    channelGroupSelect() {
      fetch({
        url: "/admin/channel_package_group/select",
        method: "GET",
      }).then((res) => {
        this.channelGroupSelectList = res.data.data;
      });
    },

    // 根据所属游戏,显示对应的所属渠道
    selectChannel(vid) {
      let obj = {};
      obj = this.gamesList.find((item) => {
        return item.id == vid;
      });
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (obj) {
          if (item.game_id == obj.id) {
            this.channelSelectList.push(item);
          }
        } else {
          this.channelSelectList.push(item);
        }
      });
      if (vid) this.getServerSelectList(vid)
    },
    // 实现渠道包数据的搜索
    searchRechargeList() {
      this.currentPage = 1;
      this.getRechargeList(true);
    },
    // 展示用户角色列表数据
    getRechargeList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = this.searchValue.channel_id.toString();
      const params = {
        ...searchValue,
        channel_id: channel_id,
        page: this.currentPage,
        per_page: this.pageSize
      }
      if (this.date && this.date.length) {
        const created_from = this.date.length === 2 && this.date[0]
        const created_to = this.date.length === 2 && this.date[1]
        if (created_from) params['created_from'] = created_from
        if (created_to) params['created_to'] = created_to
      }
      fetch({
        url: "/admin/statistics/recharge_list",
        method: "GET",
        params,
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
</style>
